export default __webpack_public_path__ + "img/back2-72d40677.png";